import Base from './base'
import urls from 'config/urls'

class Lottery extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.lottery.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.lottery.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.lottery.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.lottery.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.lottery.delete,
      data: opts
    })
  }

  findDraw (opts) {
    return this.httpGet({
      url: urls.lottery.findDraw,
      data: opts
    })
  }

  exportDraw (opts) {
    return this.httpDownload({
      url: urls.lottery.exportDraw,
      data: opts
    })
  }

  findQRCode (opts) {
    return this.httpGet({
      url: urls.lottery.findQRCode,
      data: opts
    })
  }

  createQRCode (opts) {
    return this.httpPost({
      url: urls.lottery.createQRCode,
      data: opts
    })
  }

  deleteQRCode (opts) {
    return this.httpPost({
      url: urls.lottery.deleteQRCode,
      data: opts
    })
  }

  downloadQRCode (opts) {
    return this.httpDownload({
      url: urls.lottery.downloadQRCode,
      data: opts
    })
  }

  findPrize (opts) {
    return this.httpGet({
      url: urls.lottery.findPrize,
      data: opts
    })
  }

  createPrize (opts) {
    return this.httpPost({
      url: urls.lottery.createPrize,
      data: opts
    })
  }

  updatePrize (opts) {
    return this.httpPost({
      url: urls.lottery.updatePrize,
      data: opts
    })
  }

  deletePrize (opts) {
    return this.httpPost({
      url: urls.lottery.deletePrize,
      data: opts
    })
  }

  activePrize (opts) {
    return this.httpPost({
      url: urls.lottery.activePrize,
      data: opts
    })
  }

  findPrizeXref (opts) {
    return this.httpGet({
      url: urls.lottery.findPrizeXref,
      data: opts
    })
  }

  createPrizeXref (opts) {
    return this.httpPost({
      url: urls.lottery.createPrizeXref,
      data: opts
    })
  }

  updatePrizeXref (opts) {
    return this.httpPost({
      url: urls.lottery.updatePrizeXref,
      data: opts
    })
  }

  deletePrizeXref (opts) {
    return this.httpPost({
      url: urls.lottery.deletePrizeXref,
      data: opts
    })
  }
}

export default new Lottery



// WEBPACK FOOTER //
// ./src/models/lottery.js